/**
 * @constant {String} - Represents the string used for Card payments in the DB
 */
export const CARD_PAY_TYPE = 'Card';

/**
 * @constant {String} - Represents the string used for Cash payments in the DB
 */
export const CASH_PAY_TYPE = 'Cash';
